/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TopRecommendations {
    getFixupPrototypeFunction() { return TopRecommendations.fixupPrototype; }

    static newInstance(model: Partial<TopRecommendations>): TopRecommendations {
        let obj = Object.assign(new TopRecommendations(), model);
        TopRecommendations.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TopRecommendations>): TopRecommendations {
        if (!model) return null;
        return TopRecommendations.newInstance(<TopRecommendations> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TopRecommendations) {
        if (!obj) return;

        models.TopRecommendations.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TopRecommendations): boolean {
        Object.setPrototypeOf(obj, TopRecommendations.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Response status on resource wise top recommendations
     */
    status: string;

    /**
     * top recommendations list
     */
    message: string;

    /**
     * Top Recommendation
     */
    top_recommendations: any;

}
